// import 'babel-polyfill';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as momentlocal from 'moment-timezone';

import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import Utils from './utils/utils';
import abpUserConfigurationService from './services/abpUserConfigurationService';
import initializeStores from './stores';
import { UserServiceProxy } from './services/serviceProxy';
import MaintainPage, { isMaintainBlocking } from './scenes/Maintain';

import { ConfigProvider, Modal } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import 'moment/locale/zh-cn';

declare var abp: any;

Utils.setLocalization();

const renderNetworkError = () => {
  ReactDOM.render(
    <Modal
      title="网络异常"
      centered
      okText={"重试"}
      okType='danger'
      open={true}
      footer={null}
      width={500}
    >
      <p>网络异常，请稍后重试。</p>
    </Modal>
    ,
    document.getElementById('root') as HTMLElement
  );
};

const renderMaintainPage = (message?: string | null) => {
  ReactDOM.render(
    <ConfigProvider locale={zhCN}>
      <MaintainPage message={message} />
    </ConfigProvider>
    ,
    document.getElementById('root') as HTMLElement
  );
};

const bootstrapApp = () => {
  abpUserConfigurationService.getAll().then(response => {
    const { data } = response;
    Utils.extend(true, abp, data);
    abp.clock.provider = Utils.getCurrentClockProvider(data.clock.provider);
    const currentLanguage = abp.localization.currentLanguage.name
    momentlocal.locale(currentLanguage);

    if (abp.clock.provider.supportsMultipleTimezone) {
      momentlocal.tz.setDefault(abp.timing.timeZoneInfo.iana.timeZoneId);
    }
    const stores = initializeStores();

    ReactDOM.render(
      <Provider {...stores}>
        <ConfigProvider locale={currentLanguage == 'en' ? enUS : zhCN}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ConfigProvider>
      </Provider>
      ,
      document.getElementById('root') as HTMLElement
    );

  }).catch(() => {
    renderNetworkError();
  });
};

// 所有接口加载前先检查系统维护状态
new UserServiceProxy().getMaintainInfo()
  .then((maintainInfo) => {
    if (isMaintainBlocking(maintainInfo)) {
      renderMaintainPage(maintainInfo.message);
      return;
    }
    bootstrapApp();
  })
  .catch(() => {
    // 维护接口失败（含未登录 401）时不阻断启动，避免刷新死循环
    bootstrapApp();
  });
